import "./PayoffVolSelectorComponent.scss";
import template from "./PayoffVolSelectorComponent.html";
import {IComponentOptions} from "angular";
import {ComponentCallback} from "../../../../types/AngularJS";

export const VolSelect = "tfPayoffVolSelect";

export function volSelect(): IComponentOptions {
    return {
        template,
        bindings: {
            current: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: PayoffMatrixVolSelectorComponentController
    };
}

export class PayoffMatrixVolSelectorComponentController {

    /** @input */
    public set current(current: number | null) {
        if (current == null) {
            this.vol = 0;
            this.inputVol = 0;
        } else {
            this.vol = current;
            this.inputVol = current * 100;
        }
    }

    public vol = 0;
    public inputVol = 0;

    /** @output */
    public readonly onChange: ComponentCallback;

    public readonly up = [0.5, 0.2, 0.1, 0.05];
    public readonly down = [-0.5, -0.2, -0.1, -0.05];

    public toggleAdjustment(adjustment: number) {
        if (adjustment === this.vol) {
            this.valueChanged(0);
        } else {
            this.valueChanged(adjustment);
        }
    }

    public inputVolChanged(vol: number | null) {
        if (vol == null) {
            this.valueChanged(0);
        } else {
            const change = vol / 100;
            const rounded = +change.toFixed(6);
            this.valueChanged(rounded);
        }
    }

    private valueChanged(vol: number) {
        this.onChange({vol});
    }
}
